import { render } from "./Container.vue?vue&type=template&id=b5f2cbfa&scoped=true"
import script from "./Container.vue?vue&type=script&lang=js"
export * from "./Container.vue?vue&type=script&lang=js"

import "./Container.vue?vue&type=style&index=0&id=b5f2cbfa&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-b5f2cbfa"

export default script